export const medicalComissionsReportConst = {
  title: 'REPORTE GENERAL DE COMISIONES MEDICAS POR SUCURSAL',
  header: ['MEDICO','SUCURSAL', 'SUB TOTAL', 'MONTO DE ISR', 'COMISION GENERADA'],
};
